import { Plus, BookOpenText, MessageCircle, Layers, Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { systemDownloadUrl } from "@/lib/api";
import ConnectionStatus from "./ConnectionStatus";

export default function QuickActionsSidebar({ lastSyncedAt, activeLetters = [], onSmithers, onStake }) {
    const nav = useNavigate();
    const actions = [
        {
            id: "create-project",
            icon: Plus,
            label: "Active Projects",
            sub: "Builds the ecosystem is tracking",
            onClick: () => nav("/portal/projects"),
        },
        {
            id: "resource-library",
            icon: BookOpenText,
            label: "Resource Library",
            sub: "Templates · doctrine · references",
            onClick: () => nav("/portal/workspace"),
        },
        {
            id: "smithers",
            icon: MessageCircle,
            label: "Contact Smithers",
            sub: "Operational guidance · coming soon",
            onClick: onSmithers,
        },
        {
            id: "stake",
            icon: Layers,
            label: "Creator's Stake",
            sub: "Rendering bridge · awaiting sync",
            onClick: onStake,
        },
    ];

    return (
        <aside data-testid="quick-actions-sidebar" className="space-y-6">
            <section>
                <div className="font-mono-tight text-[10px] uppercase tracking-[0.32em] text-tca-cyan/75 mb-3">
                    // Quick Actions
                </div>
                <div className="space-y-2.5">
                    {actions.map((a) => {
                        const Icon = a.icon;
                        return (
                            <button
                                key={a.id}
                                type="button"
                                onClick={a.onClick}
                                data-testid={`qa-${a.id}`}
                                className="
                                    group w-full text-left
                                    border border-tca-cyan/18 hover:border-tca-cyan/55
                                    bg-tca-bg-panel/55 backdrop-blur-md px-4 py-3
                                    transition-all duration-300
                                "
                            >
                                <div className="flex items-center gap-3">
                                    <Icon size={15} strokeWidth={1.6} className="text-tca-cyan group-hover:text-tca-cyan-hi" />
                                    <div className="min-w-0">
                                        <div className="text-sm text-tca-ink">{a.label}</div>
                                        <div className="text-[11px] text-tca-ink-muted truncate">{a.sub}</div>
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </section>

            <section>
                <div className="font-mono-tight text-[10px] uppercase tracking-[0.32em] text-tca-cyan/75 mb-3">
                    // Module Shortcuts
                </div>
                <div className="grid grid-cols-4 gap-1.5">
                    {(activeLetters.slice(0, 8)).map((L) => (
                        <button
                            key={L}
                            type="button"
                            onClick={() => nav(`/portal/module/${L}`)}
                            data-testid={`qa-letter-${L}`}
                            className="
                                font-mono-tight font-semibold text-sm
                                py-3 border border-tca-cyan/35 hover:border-tca-cyan
                                text-tca-cyan hover:text-tca-cyan-hi
                                bg-tca-cyan/3 hover:bg-tca-cyan/10
                                transition-all duration-300
                            "
                        >
                            {L}
                        </button>
                    ))}
                </div>
            </section>

            <section>
                <div className="font-mono-tight text-[10px] uppercase tracking-[0.32em] text-tca-cyan/75 mb-3">
                    // System Kit
                </div>
                <a
                    href={systemDownloadUrl()}
                    data-testid="qa-download-system"
                    className="
                        group inline-flex items-center gap-2 w-full justify-center
                        font-mono-tight font-semibold uppercase tracking-[0.18em] text-[11px]
                        py-3 border border-tca-cyan text-tca-cyan-hi
                        bg-gradient-to-b from-[rgba(0,219,255,0.18)] to-[rgba(0,219,255,0.04)]
                        hover:text-white hover:shadow-glow-cyan-xs
                        rounded-full transition-all
                    "
                >
                    <Download size={13} /> Download Package
                </a>
            </section>

            <section className="border-t border-tca-ink-dim/30 pt-5">
                <ConnectionStatus lastSyncedAt={lastSyncedAt} />
            </section>
        </aside>
    );
}
